import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';

import { INTERVIEW_V2_ROUTER } from '../routes/routes';
import { selectTaxProfileState } from '../selectors/tax.selector';
import { selectAccountInfo } from '../selectors/account.selector';

interface UseInterviewFlowProps {
    prizeId?: string;
    eventName?: string;
    isRetake?: boolean;
}

export const useInterviewFlow = ({
    prizeId,
    eventName,
    isRetake = false
}: UseInterviewFlowProps) => {
    const history = useHistory();
    const taxProfileState = useSelector(selectTaxProfileState);
    const accountInfo = useSelector(selectAccountInfo);

    const handleStartTaxInterview = useCallback(
        (dob?: string, showAgeGate?: boolean) => {
            window.scrollTo(0, 0);
            history.push({
                pathname: INTERVIEW_V2_ROUTER,
                state: {
                    prizeId,
                    eventName,
                    isRetake,
                    dob,
                    showAgeGate
                }
            });
        },
        [history, prizeId, eventName, isRetake]
    );

    const handleButtonClick = useCallback(
        (gated?: boolean) => {
            const hasTaxInfoOrDob = Boolean(
                taxProfileState?.taxProfile?.recordIdentityKey || accountInfo?.dateOfBirth
            );
            const showAgeGate = Boolean(!hasTaxInfoOrDob || gated);
            handleStartTaxInterview(accountInfo?.dateOfBirth, showAgeGate);
        },
        [taxProfileState?.taxProfile, accountInfo?.dateOfBirth, handleStartTaxInterview]
    );

    const handleConfirm = useCallback(() => {
        handleButtonClick();
    }, [handleButtonClick]);

    return {
        handleButtonClick,
        handleConfirm,
        handleStartTaxInterview
    };
};
